module.exports = __webpack_public_path__ + "static/img/device_s1_max.487ecc30.png";